import * as React from 'react'
import styled from '../../../common/src/components/styled'
import { Colors, Fonts } from '../../../common/src/constants'
import { diffFmt } from '../../../common/src/date'
import { FetchAgentVirtualTourQuery } from '../../../common/src/types.gen'

const Root = styled.div({
  fontSize: 32,
  fontFamily: Fonts.sansHeader,
})

const CountDown = styled.span({
  color: Colors.sky,
})

interface NextVirtualAppointmentInfoTitleProps {
  now: Date
  showing?: NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']>['showing'] | null
}

const NextVirtualAppointmentInfoTitle = (props: NextVirtualAppointmentInfoTitleProps) => {
  const { now, showing } = props

  if (showing?.calEvent == null) {
    return <Root>No virtual appointment</Root>
  }

  return (
    <Root>
      Next virtual in <CountDown>{diffFmt(showing.calEvent.timeStart, now)}</CountDown>
    </Root>
  )
}

export default NextVirtualAppointmentInfoTitle
